'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchPagesTotals = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _client = require('../../../utils/client');

var _params = require('../../../utils/params');

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var fetchPagesTotals = function fetchPagesTotals() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  var search = _ref.search,
      params = _objectWithoutProperties(_ref, ['search']);

  var finalParams = _extends({}, params, {
    page: 1,
    limit: 1
  });

  var mappings = {
    type: 'type',
    startDate: 'start_updated_at',
    endDate: 'end_updated_at'
  };

  var transforms = {
    type: function type(_type) {
      switch (_type) {
        case 'individual':
          return search ? 'user' : 'individual';
        default:
          return _type;
      }
    }
  };

  var url = search ? 'api/v2/search/pages' : 'api/v2/pages';

  return (0, _client.get)(url, finalParams, { mappings: mappings, transforms: transforms }).then(function (_ref2) {
    var meta = _ref2.meta;
    return search ? meta.pagination.count : meta.count;
  });
};
exports.fetchPagesTotals = fetchPagesTotals;


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/pages-totals/everydayhero/index.js
// module id = 1333
// module chunks = 0